import { ChangeEvent, FC } from "react";
import { PinInput } from "../../base/input/pin-input";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { verifyOtpCode } from "../../../redux/requests/IdentificationRequests";

interface IVerificationCodeInputMDProps {
  phone: string;
}

export const VerificationCodeInputMD: FC<IVerificationCodeInputMDProps> = ({
  phone,
}) => {
  const isLoading = useAppSelector((state) => state.user.isLoading);
  const dispatch = useAppDispatch();

  const onOtpCodeInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.value) return;
    if (event.target.value.length === 6) {
      dispatch(verifyOtpCode(phone, event.target.value));
    }
  };

  return (
    <PinInput size="md" onChange={onOtpCodeInputChange} disabled={isLoading}>
      <PinInput.Label>Secure code</PinInput.Label>
      <PinInput.Group maxLength={6} pattern={REGEXP_ONLY_DIGITS}>
        <PinInput.Slot index={0} className="bg-gray-50 h-16" />
        <PinInput.Slot index={1} className="bg-gray-50 h-16" />
        <PinInput.Slot index={2} className="bg-gray-50 h-16" />
        <PinInput.Slot index={3} className="bg-gray-50 h-16" />
        <PinInput.Slot index={4} className="bg-gray-50 h-16" />
        <PinInput.Slot index={5} className="bg-gray-50 h-16" />
      </PinInput.Group>
    </PinInput>
  );
};
